import React, { useEffect } from 'react'
import { Container, Grid2, Typography } from '@mui/material'
import { keyframes } from '@mui/system';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CircleIcon from '@mui/icons-material/Circle';
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Navbar from './Navbar'
import ProductionCharts from '../charts/ProductionCharts';
import GaugeChart from '../charts/GaugeChart';

function DashbaordBlock(props) {
    // const dispatch = useDispatch()
    const navigate = useNavigate()
    const year = props.year
    const Volume = props.Volume
    const taskColor = props.taskColor
    const currCondition = props.currCondition
    const typoStyle = {
        textAlign: 'center', fontSize: 20, fontWeight: 'bolder', color: 'white', textShadow: 'black 3px 3px 5px',

    }

    const moveUp = keyframes`
        0% {
            transform: translateY(30px);
        }
        50% {
            transform: translateY(0); /* Change position by 200px */
        }
        100% {
            transform: translateY(30px); /* Change position by 200px */
        }`;

    const getYearData = async (year) => {
        global.targetYear = year
        // const yearData = { targetYear: year }
        // dispatch(getcws(yearData))
        navigate('/CWS')
    }
    return (
        <>
            <Grid2 container spacing={1} sx={{
                background: 'linear-gradient(90deg, rgba(16,191,248,1) 0%, rgba(15,150,248,1) 100%)', padding: 2, borderRadius: 2,
                boxShadow: 'black 2px 2px 5px',
                cursor: 'pointer'
            }}
                onClick={() => getYearData(year)}
            >
                <Grid2 size={8} sx={{ background: `${taskColor}, 0.5)`, borderRadius: 5, }}>
                    <Typography style={{ ...typoStyle, fontSize: 30 }} > {year}</Typography>
                </Grid2>
                <Grid2 size={4} >
                    <Typography style={{ textAlign: 'right', color: `${taskColor}, 1)` }}>{currCondition === 'nor' ?
                        <CircleIcon fontSize="large" /> : currCondition === 'Inc' ?
                            <ArrowUpwardIcon fontSize="large"
                                sx={{
                                    borderRadius: 50,
                                    boxShadow: 'yellow 0px 4px 15px',
                                    // animation: 'blinkingText 1.5s infinite',
                                    // '@keyframes blinkingText': {
                                    //     '0%': { boxShadow: '#ceb600 0px 10px 25px' },
                                    //     '50%': { boxShadow: '#ceb600 0px 0px 0px' },
                                    //     '100%': { boxShadow: '#ceb600 0px 10px 25px' },
                                    // },
                                    animation: `${moveUp} 2s ease-in-out infinite alternate`,
                                }}
                            /> :
                            <ArrowDownwardIcon fontSize="large"
                                sx={{
                                    // boxShadow: 'red 0px 4px 15px',
                                    // borderRadius: 50,
                                    // animation: `${moveDown} 2s ease-in-out infinite alternate`,

                                }} />}</Typography>
                </Grid2>
                <Grid2 size={12}>
                    <Typography style={typoStyle}>$ {Volume && Volume.toLocaleString("en-US")}</Typography>
                </Grid2>
            </Grid2 >
        </>
    );
}


export default function Dashbaord() {

    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    const navigate = useNavigate()

    const { user } = useSelector(state => state.auth)

    const { yws, isLoading } = useSelector(state => state.analyzation)

    useEffect(() => {
        if (!user) {
            navigate('SignIn')
        }
    }, [user, navigate])

    return (
        <>
            <Navbar />
            <Container sx={{ mt: 2 }} >
                <Grid2 container spacing={2}>
                    <Grid2 size={6}>
                        <ProductionCharts title='Production' barColor='#65aa5a' />
                    </Grid2>
                    <Grid2 size={6}>
                        <ProductionCharts title='Sales' barColor='#772727' />
                    </Grid2>
                    <Grid2 size={6}>
                        <GaugeChart title='Sales' barColor='#772727' />
                    </Grid2>
                </Grid2>
            </Container >
        </>
    )
}
